<template>
  <form
    class="cn-search-form"
    :class="[{ 'cn-search-form--dark': dark }]"
    @submit.prevent="search"
  >
    <div class="cn-search-form__wrapper">
      <UiInput
        ref="target"
        v-model.trim="searchTextLocal"
        icon="search"
        :placeholder="$t('search_placeholder')"
      />
      <UiButton :variant="buttonVariant" type="submit">
        {{ $t('search') }}
      </UiButton>
    </div>
    <div v-if="hint" class="cn-search-form__hint">
      {{ hint }}
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import type { ButtonVariant } from './UiButton.vue';
import UiInput from '@/components/ui/UiInput';
import UiButton from '@/components/ui/UiButton';

interface Props {
  modelValue?: string | null;
  hint?: string | null;
  dark?: boolean;
  buttonVariant?: ButtonVariant;
  initialFocus?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  hint: null,
  dark: false,
  buttonVariant: 'red',
  initialFocus: false,
});

const emit = defineEmits<{
  (e: 'update:modelValue' | 'search', data: string | null): void;
}>();

const searchTextLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const search = () => {
  emit('search', searchTextLocal.value);
};

const target = ref();
// TODO: refactor input focus
const focusInput = () => {
  if (!props.initialFocus) return;
  target.value.$refs.input.focus();
};

onMounted(() => {
  focusInput();
});
</script>

<style lang="scss">
.cn-search-form {
  --ab-canyon-search-form-hint-color-text: var(--ab-canyon-color-neutral-dark);
  --ab-canyon-search-form-hint-color-text-dark: var(--ab-canyon-color-light);
  &__wrapper {
    row-gap: var(--size-base);
    column-gap: var(--size-xl);
    flex-direction: column;
    display: flex;
    @media (min-width: 656px) {
      align-items: center;
      flex-direction: row;
    }
  }
  &__hint {
    color: var(--ab-canyon-search-form-hint-color-text);
    font-size: 0.75rem;
    line-height: 1rem;
    margin-top: var(--size-base);
  }
  &--dark {
    .cn-search-form {
      &__hint {
        color: var(--ab-canyon-search-form-hint-color-text-dark);
      }
    }
  }
}
</style>
